import React, { useEffect, useRef } from 'react';
import { VideoJsPlayer } from 'video.js';

type ControlBarCurrentTimeProps = {
  player: VideoJsPlayer;
  formatTime: (time: number) => string | number;
};

export default function ControlBarCurrentTime({
  player,
  formatTime
}: ControlBarCurrentTimeProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let raf = 0;
    let prevValue = '';

    const update = () => {
      const value = String(formatTime(player.currentTime()));
      if (value !== prevValue && ref.current) {
        prevValue = value;
        ref.current.textContent = value;
      }
      raf = requestAnimationFrame(update);
    };

    update();
    return () => cancelAnimationFrame(raf);
  }, [formatTime, player]);

  return <div className="current" ref={ref} />;
}
